import { render, staticRenderFns } from "./DxPhenologiesDatabase.vue?vue&type=template&id=e43e7f4a&"
import script from "./DxPhenologiesDatabase.vue?vue&type=script&lang=js&"
export * from "./DxPhenologiesDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports